'use client'

import { TriangleIcon, XIcon } from '@phosphor-icons/react'
import { cva } from 'class-variance-authority'
import { useState, useTransition } from 'react'

import { cn } from '@/lib/utils'

import { closeBannerAction } from './actions'

import type { ReactNode } from 'react'

const headerBannerVariants = cva('text-white w-full', {
  variants: {
    variant: {
      Info: 'bg-primary-700 py-2',
      Warning: 'py-4 bg-warning-700 text-white',
      Danger: 'py-4 bg-error-700 text-white',
    },
  },
  defaultVariants: {
    variant: 'Info',
  },
})

export const BannerClient = ({
  id,
  variant,
  isMarketingVariant,
  children,
}: {
  id: string
  variant: 'Info' | 'Warning' | 'Danger'
  isMarketingVariant: boolean
  children: ReactNode
}) => {
  const [isVisible, setIsVisible] = useState(true)
  const [isPending, startTransition] = useTransition()

  const handleClose = () => {
    // Optimistically hide the banner
    setIsVisible(false)

    // Set the cookie via server action
    startTransition(async () => {
      await closeBannerAction(id)
    })
  }

  if (!isVisible) return null

  return (
    <div className={cn('relative z-50', headerBannerVariants({ variant }))}>
      <div className="mx-auto flex max-w-container items-center justify-center px-4 lg:px-12 desktop:max-w-content desktop:px-0">
        {!isMarketingVariant && <TriangleIcon size={26} color="white" className="mr-3" />}
        {children}
        {!isMarketingVariant && (
          <button title="Close" onClick={handleClose} disabled={isPending} className="ml-auto">
            <XIcon color="white" size={24} />
          </button>
        )}
      </div>
    </div>
  )
}
